(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.cpReady) return;
      root.dataset.cpReady = 'true';

      var form = root.querySelector('[data-cp-form]');
      var sort = root.querySelector('[data-cp-sort]');
      var drawer = root.querySelector('[data-cp-drawer]');
      var open = root.querySelector('[data-cp-open]');
      var close = root.querySelector('[data-cp-close]');

      if (sort && form) {
        sort.addEventListener('change', function () {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        });
      }

      if (drawer && open) {
        open.addEventListener('click', function () {
          if (drawer.showModal) drawer.showModal();
          else drawer.setAttribute('open', '');
        });
        if (close) {
          close.addEventListener('click', function () { drawer.close(); });
        }
        drawer.addEventListener('click', function (event) {
          var rect = drawer.getBoundingClientRect();
          var inside =
            event.clientX >= rect.left && event.clientX <= rect.right &&
            event.clientY >= rect.top && event.clientY <= rect.bottom;
          if (!inside) drawer.close();
        });
      }

      Array.prototype.forEach.call(root.querySelectorAll('[data-cp-add]'), function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          button.disabled = true;
          fetch(root.dataset.cartUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(button.dataset.cpAdd, 10), quantity: 1 }] })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('add failed');
              return response.json();
            })
            .then(function () {
              button.classList.add('is-done');
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              if (root.dataset.redirect === 'true') {
                window.location.href = root.dataset.cartPage;
                return;
              }
              setTimeout(function () {
                button.classList.remove('is-done');
                button.disabled = false;
              }, 1800);
            })
            .catch(function () {
              button.disabled = false;
              window.location.href = button.closest('.cp__card').querySelector('.cp__title').href;
            });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-cp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function init(root) {
      if (root.dataset.hcbReady) return;
      root.dataset.hcbReady = 'true';

      var hours = root.querySelector('[data-hcb-hours]');
      var minutes = root.querySelector('[data-hcb-minutes]');
      var seconds = root.querySelector('[data-hcb-seconds]');
      if (!hours || !minutes || !seconds) return;

      function tick() {
        var now = new Date();
        var next = new Date(now);
        next.setHours(24, 0, 0, 0);
        var diff = Math.max(0, Math.floor((next - now) / 1000));
        hours.textContent = pad(Math.floor(diff / 3600));
        minutes.textContent = pad(Math.floor((diff % 3600) / 60));
        seconds.textContent = pad(diff % 60);
      }

      tick();
      setInterval(tick, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-hcb]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["influencers-choice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var X = [0, 0.8, 1.33, 1.72];
    var S = [1, 0.8, 0.67, 0.57];
    var O = [1, 1, 0.5, 0.38];

    function init(root) {
      if (root.dataset.ifcReady) return;
      var stage = root.querySelector('[data-ifc-stage]');
      if (!stage) return;
      root.dataset.ifcReady = 'true';

      var track = root.querySelector('[data-ifc-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ifc-card]'));
      var prev = root.querySelector('[data-ifc-prev]');
      var next = root.querySelector('[data-ifc-next]');
      var active = Math.floor((cards.length - 1) / 2);
      var startX = null;
      var dragged = false;

      function pauseAll(except) {
        cards.forEach(function (card) {
          if (card === except) return;
          var video = card.querySelector('[data-ifc-video]');
          var button = card.querySelector('[data-ifc-play]');
          if (video && !video.paused) video.pause();
          card.dataset.playing = 'false';
          if (button) {
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', 'Play video');
          }
        });
      }

      function render() {
        cards.forEach(function (card, i) {
          var d = i - active;
          var a = Math.abs(d);
          var sign = d < 0 ? -1 : 1;
          var hidden = a > 3;
          var idx = hidden ? 3 : a;
          var x = hidden ? sign * 1.95 : sign * X[idx];
          card.style.setProperty('--x', x);
          card.style.setProperty('--s', hidden ? 0.5 : S[idx]);
          card.style.setProperty('--o', hidden ? 0 : O[idx]);
          card.style.setProperty('--z', 10 - Math.min(a, 9));
          card.style.pointerEvents = hidden ? 'none' : '';
          card.dataset.active = a === 0 ? 'true' : 'false';
          card.setAttribute('aria-hidden', a === 0 ? 'false' : 'true');
          var interactive = card.querySelectorAll('[data-ifc-link], [data-ifc-play]');
          Array.prototype.forEach.call(interactive, function (el) {
            el.tabIndex = a === 0 ? 0 : -1;
          });
        });
        if (prev) prev.disabled = active <= 0;
        if (next) next.disabled = active >= cards.length - 1;
        pauseAll(cards[active]);
      }

      function go(index) {
        var target = Math.max(0, Math.min(cards.length - 1, index));
        if (target === active) return;
        active = target;
        render();
      }

      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });

      stage.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(active - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); go(active + 1); }
      });

      cards.forEach(function (card, i) {
        card.addEventListener('click', function (event) {
          if (i !== active) {
            event.preventDefault();
            event.stopPropagation();
            go(i);
          }
        }, true);

        var button = card.querySelector('[data-ifc-play]');
        var video = card.querySelector('[data-ifc-video]');
        if (button && video) {
          button.addEventListener('click', function () {
            if (video.paused) {
              pauseAll(card);
              video.muted = false;
              var promise = video.play();
              if (promise && promise.catch) {
                promise.catch(function () {
                  video.muted = true;
                  video.play();
                });
              }
              card.dataset.playing = 'true';
              button.setAttribute('aria-pressed', 'true');
              button.setAttribute('aria-label', 'Pause video');
            } else {
              video.pause();
              card.dataset.playing = 'false';
              button.setAttribute('aria-pressed', 'false');
              button.setAttribute('aria-label', 'Play video');
            }
          });
        }
      });

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        startX = event.clientX;
        dragged = false;
      });

      track.addEventListener('pointermove', function (event) {
        if (startX === null) return;
        if (Math.abs(event.clientX - startX) > 8) dragged = true;
      });

      track.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) > 40) go(active + (delta < 0 ? 1 : -1));
      });

      track.addEventListener('pointercancel', function () { startX = null; });
      track.addEventListener('pointerleave', function () { startX = null; });

      track.addEventListener('click', function (event) {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      }, true);

      root.addEventListener('shopify:block:select', function (event) {
        var index = cards.indexOf(event.target);
        if (index > -1) go(index);
      });

      render();
    }

    function initAll() {
      document.querySelectorAll('[data-ifc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.qtsReady) return;
      var track = root.querySelector('[data-qts-track]');
      if (!track) return;
      root.dataset.qtsReady = 'true';

      var prev = root.querySelector('[data-qts-prev]');
      var next = root.querySelector('[data-qts-next]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-qts-card]'));
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var card = cards[0];
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function move(direction) {
        var max = track.scrollWidth - track.clientWidth;
        var target = track.scrollLeft + direction * step();
        if (direction > 0 && track.scrollLeft >= max - 4) target = 0;
        if (direction < 0 && track.scrollLeft <= 4) target = max;
        track.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });

      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-qts-video]'));
      if (!reduced && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              video.muted = true;
              var promise = video.play();
              if (promise && promise.catch) promise.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.4 });
        videos.forEach(function (video) { observer.observe(video); });
      }

      root.addEventListener('shopify:block:select', function (event) {
        var card = event.target;
        if (cards.indexOf(card) > -1) {
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-qts]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-testimonials-viewport]').forEach(function (viewport) {
      var track = viewport.querySelector('[data-testimonials-track]');
      var nav = viewport.parentElement.querySelector('[data-testimonials-nav]');
      if (!track || !nav) return;

      var prevBtn = nav.querySelector('[data-testimonials-prev]');
      var nextBtn = nav.querySelector('[data-testimonials-next]');
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-testimonials-card]'));
      var index = 0;

      function getVisibleCount() {
        var w = window.innerWidth;
        if (w <= 749) return 1;
        if (w <= 989) return 2;
        return 3;
      }

      function getStep() {
        if (cards.length < 2) return 0;
        var first = cards[0].getBoundingClientRect();
        var second = cards[1].getBoundingClientRect();
        return second.left - first.left;
      }

      function update() {
        var visible = getVisibleCount();
        var maxIndex = Math.max(0, cards.length - visible);
        if (index > maxIndex) index = maxIndex;
        if (index < 0) index = 0;

        var step = getStep();
        var offset = index * step;
        track.style.transform = 'translateX(-' + offset + 'px)';

        prevBtn.disabled = index <= 0;
        nextBtn.disabled = index >= maxIndex;
      }

      prevBtn.addEventListener('click', function () {
        index = Math.max(0, index - 1);
        update();
      });

      nextBtn.addEventListener('click', function () {
        var visible = getVisibleCount();
        var maxIndex = Math.max(0, cards.length - visible);
        index = Math.min(maxIndex, index + 1);
        update();
      });

      window.addEventListener('resize', update);
      window.requestAnimationFrame(update);
      update();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
